import { Ui5ReactGenerator } from "./GeneratorUi5React";
export default Ui5ReactGenerator;
